export default __webpack_public_path__ + "static/media/Ballroll_00121.8ca82444.png";